// Get the elements
const cartButton = document.getElementById('cart-button')
const cartDrawer = document.getElementById('cart-drawer')
const closeCartButton = document.getElementById('x')

// Function to toggle the cart drawer
function toggleCartDrawer() {
  // Toggle the 'open' class on the cart drawer
  cartDrawer.classList.toggle('open')

  // Optionally, add a 'no-scroll' class to the body to prevent scrolling when the drawer is open
  document.body.classList.toggle(
    'no-scroll',
    cartDrawer.classList.contains('open')
  )
}

// Add event listener to the cart button
cartButton.addEventListener('click', toggleCartDrawer)
closeCartButton.addEventListener('click', toggleCartDrawer)
